import { createFileRoute } from '@tanstack/react-router';

import { About } from '#modules/user/features/profile/components/Settings/About';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/about'
)({
  component: About,
  ssr: false,
  /**
   * This screen *is* the footer — it exists because signed-in users and the app don't get one.
   * On the web they did get one anyway (SlimFooter), so the page ended with the copyright
   * twice and Terms/Privacy twice, one pair under the other (screenshot, 07.08.2026).
   *
   * Same flag the landings use to keep the global footer from stacking under their own. The
   * Header reads it too, but only to give *logged-out* visitors marketing nav — and nobody
   * reaches an `_authed` route logged out, so the header is unaffected. The language switch
   * that lives in the slim footer is not lost either: Settings has its own (UpdateLanguage).
   */
  staticData: { rendersOwnFooter: true },
});
